"use client";
import {
  useCompositeStore
} from "../__chunks/UVQLZ7T5.js";
import "../__chunks/TCAGH6BH.js";
import {
  CompositeContextProvider
} from "../__chunks/WENSINUV.js";
import "../__chunks/FMYQNSCK.js";
import "../__chunks/HKOOKEDE.js";
import "../__chunks/2GXGCHW6.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/composite/composite-provider.tsx
import { jsx } from "react/jsx-runtime";
function CompositeProvider(props = {}) {
  const store = useCompositeStore(props);
  return /* @__PURE__ */ jsx(CompositeContextProvider, { value: store, children: props.children });
}
export {
  CompositeProvider
};
